import { Controller } from "@hotwired/stimulus";

// Live-format a phone input into "xxx-xxx-xxxx" as the user types.
// Attach with data-controller="phone-field" directly on the input element.
export default class extends Controller {
  connect() {
    this.element.addEventListener("input", this.format);
    // Format any value the server pre-filled (e.g. a resumed draft).
    this.applyMask();
  }

  disconnect() {
    this.element.removeEventListener("input", this.format);
  }

  format = (event) => {
    // Let deletions through untouched so backspace works naturally.
    if (event.inputType && event.inputType.startsWith("delete")) return;
    this.applyMask();
  };

  applyMask() {
    const digits = this.element.value.replace(/\D/g, "").slice(0, 10);
    let formatted = digits;
    if (digits.length > 6) {
      formatted = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
    } else if (digits.length > 3) {
      formatted = `${digits.slice(0, 3)}-${digits.slice(3)}`;
    }
    this.element.value = formatted;
  }
}
